package amazon.lastmile.inject

import app.nestbridge.feature.profile.ui.CreateProfessionalProfileUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateProfessionalProfileUiFactory::class)
public interface AppNestbridgeFeatureProfileUiCreateProfessionalProfileUiFactory {
  @Provides
  @IntoSet
  public fun provideCreateProfessionalProfileUiFactoryFactoryMultibinding(createProfessionalProfileUiFactory: CreateProfessionalProfileUiFactory): Ui.Factory = createProfessionalProfileUiFactory
}
